export const learnMoreExerciseCards = [
    {
        title: '',
        subTitle: '',
        imageURL: ''
    },
    {
        title: 'Stay Home, Stay Fit',
        subTitle:
            'Great fitness can happen wherever you are. Whether you want to strengthen your core, or even improve your form - we got your back.',
        imageURL: 'https://asset.yes.fit/homepage/lm-exercises-01.png'
    },
    {
        title: 'Bite-Sized Fitness',
        subTitle:
            'You’re a busy person, we totally get it! That’s why these exercises are crafted to fit into the hustle of your everyday life. In under 20 minutes, these routines will have you sweating and ready to face the day.',
        imageURL: 'https://asset.yes.fit/homepage/lm-exercises-02.png'
    },
    {
        title: 'Get Fit for Free',
        subTitle:
            'We have a variety of routines that are completely <b>FREE</b> in our app and online. Want even more? <a class="underline text-yf-green" href="/membership">Become a VIP Member</a> and get instant access to our entire fitness library.',
        imageURL: 'https://asset.yes.fit/homepage/Learn-More-Exercise.gif'
    }
]
